export default "__VITE_ASSET__Bcq_kxe8__"